{
 "_meta": {
  "locale": "tr",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Şimdi",
  "people": "Kişiler",
  "cases": "Dosyalar",
  "agenda": "Ajanda",
  "reviews": "Gözden geçirmeler",
  "prospects": "Müşteri adayları",
  "insights": "Analizler",
  "data": "Veri ve güvenlik",
  "settings": "Ayarlar",
  "lens": "Mercek"
 },
 "common": {
  "save": "Kaydet",
  "cancel": "İptal",
  "close": "Kapat",
  "search": "Ara",
  "today": "Bugün",
  "tomorrow": "Yarın",
  "new": "Yeni",
  "edit": "Düzenle",
  "delete": "Sil"
 },
 "settings": {
  "title": "Ayarlar",
  "language": "Dil",
  "region": "Pazar / bölge",
  "theme": "Görünüm"
 },
 "people": {
  "title": "Kişiler",
  "new": "Yeni kişi"
 },
 "today": {
  "agenda_title": "Bugün"
 },
 "lens": {
  "placeholder": "Kişi, aday, dosya arayın — veya bir komut yazın"
 }
}